import { formatNumber } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Calculators } from '@local/client-contracts';

@Component({
  selector: 'calc-result-item',
  templateUrl: './calc-result-item.component.html',
  styleUrls: ['./calc-result-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalcResultItemComponent {
  @Input() selected: boolean;
  @Input() model: Calculators.Item;
  @Input() index: number;
  @Output() disclaimerClick = new EventEmitter<string>();

  public get disclaimerName(): string {
    return this.model.resource.result.disclaimer.name;
  }

  public get disclaimerLastUpdate(): number {
    return this.model.resource.result.disclaimer.timestamp * 1000;
  }

  public get queryDisplayText(): string {
    return `${this.model.resource.result.amount?.toLocaleString() || ''}${this.model.resource.result.type === 'Temperature' ? '' : ' '}${
      this.model.resource.result.source
    } ${this.model.resource.result.dest ? 'to' : ''} ${this.model.resource.result.dest || ''}`;
  }

  public get resultDisplayText(): string {
    const { displayText, type, dest } = this.model.resource.result;
    switch (type) {
      case 'Math':
      case 'Temperature':
      case 'Timezone':
      case 'Currency':
        return displayText;
      default:
        const parsed: number = parseFloat(displayText);
        return `${Math.abs(parsed) > 1e-7 ? formatNumber(parsed, 'en-US', '1.0-7') : parseFloat(parsed.toPrecision(6))}${dest}`;
    }
  }

  public onDisclaimerLinkClick(): void {
    const link = this.model.resource.result.disclaimer.link;
    this.disclaimerClick.emit(link);
    event.stopPropagation();
  }
}
